module.exports = __webpack_public_path__ + "static/cloud_giant_castle-9a19d5f986b2d9e5865546686b84c369.png";